<div class="container-fluid" wl-ng-models-valid (onValidChange)="handleFormValidChanged($event)">
  <wl-busy [show]="loading"></wl-busy>
  <div class="form-horizontal" [hidden]="loading" *ngIf="message">
    <div class="form-group">
      <label class="control-label col-sm-3 col-lg-2">
        {{ 'communications.mass-comm-message-edit.message-edit.subject-label' | translate | titlecase }}
      </label>
      <div class="col-sm-9 col-lg-10">
        <input
          type="text"
          class="form-control"
          #messageSubjectField="ngModel"
          [(ngModel)]="message.Subject"
          [disabled]="readonly && (!isResend || (isScheduled ? message.MessageSent : false))"
          [required]="!readonly"
        />
        <div class="text-danger" [hidden]="!messageSubjectField.errors?.required">{{ 'common.required' | translate | titlecase }}</div>
      </div>
    </div>
    <div class="form-group" *ngIf="htmlTemplates?.length">
      <label class="control-label col-sm-3 col-lg-2">
        {{ 'communications.mass-comm-message-edit.message-edit.template-label' | translate | titlecase }}
      </label>
      <div class="col-sm-9 col-lg-10">
        <select
          class="form-control"
          [(ngModel)]="selectedHtmlTemplateId"
          (change)="handleHtmlTemplateSelected()"
          [disabled]="readonly && (!isResend || (isScheduled ? message.MessageSent : false))"
        >
          <option></option>
          <option *ngFor="let template of htmlTemplates" [value]="template.ID">
            {{ template.Title }}
          </option>
        </select>
      </div>
    </div>
    <div class="form-group">
      <div class="col-sm-offset-3 col-lg-offset-2 col-sm-9 col-lg-10">
        <div *ngIf="!message.Text">
          <wl-modular-wysiwyg-editor
            #messageMessageField="ngModel"
            [(ngModel)]="message.Message"
            [emailContent]="true"
            [disabled]="readonly"
            [required]="!readonly"
            [quickInsertListLabel]="'communications.mass-comm-message-edit.message-edit.special-fields-dropdown-label' | translate"
            [quickInsertList]="specialFields"
          ></wl-modular-wysiwyg-editor>
        </div>
        <div *ngIf="message.Text">
          <textarea
            #messageTextField="ngModel"
            pInputTextarea
            style="width: 100%"
            [required]="!readonly"
            name="message"
            [rows]="15"
            [(ngModel)]="message.Message"
            [autoResize]="false"
          ></textarea>
        </div>
        <div class="text-danger" [hidden]="message.Message">
          {{ 'common.required' | translate | titlecase }}
        </div>
        <div class="mct-flex mct-row mct-justify-end mct-items-stretch"  >
          <button pButton type="button" class="mv-5 atlas-btn atlas-btn-secondary" (click)="openHtmlDialog()">
            {{
              message.Text
                ? ('communications.mass-comm-message-edit.message-edit.use-internal-editor' | translate | titlecase)
                : ('communications.mass-comm-message-edit.message-edit.use-external-html' | translate)
            }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<p-dialog
  #confirmHtmlTemplateAction
  modal="true" [(visible)]="showModal"
  [closable]="false"
  styleClass="atlas-dialog-s"
  [focusOnShow]="false"
  [contentStyle]="{ 'max-height': '75vh' }"
>
  {{ 'communications.mass-comm-message-edit.message-edit.existing-message-replace-prompt' | translate }}
  <ng-template pTemplate="footer">
    <button pButton type="button" class="atlas-btn atlas-btn-default" (click)="handleConfirmHtmlTemplateReplaceClick()">
      {{ 'communications.mass-comm-message-edit.message-edit.overrite-existing-message' | translate | titlecase }}
    </button>

    <button pButton type="button" class="atlas-btn atlas-btn-default" (click)="handleConfirmHtmlTemplateAppendClick()">
      {{ 'communications.mass-comm-message-edit.message-edit.append-to-existing-message' | translate | titlecase }}
    </button>

   <button pButton type="button" class="btn btn-secondary" (click)="this.showModal = false" icon="pi pi-ban">
      {{ 'common.cancel' | translate | titlecase }}
    </button>
  </ng-template>
</p-dialog>

<wl-mass-comm-message-html-editor-dialog (messageTextToggled)="toggleMessageText()"></wl-mass-comm-message-html-editor-dialog>
